module.exports = __webpack_public_path__ + "img/Press-pause-amico.506c3e50.svg";